// extracted by mini-css-extract-plugin
export default {"sectionTitle":"section-title_sectionTitle__K+0ZU"};